/** @format */
import angular from 'angular';
import _ from 'lodash';
import { approvalStateModelModule } from '../model/approvalState.model';

export const approvalStateUtilServiceModule = 'sis-components.approvalStateUtils';

(function () {
    angular.module(approvalStateUtilServiceModule, [approvalStateModelModule]).service('ApprovalStateUtils', [
        '$http',
        'approvalStateModel',
        'APPROVAL_STATE',
        function ($http, approvalStateModel, APPROVAL_STATE) {
            const api = {
                makeStateRequest(jsDataModel, studyIds, targetState, dryRun) {
                    const restOptions = { params: { dryRun } };
                    let restEndpoint = jsDataModel.endpoint;

                    if (APPROVAL_STATE.APPROVED === targetState) {
                        restEndpoint += '/approve/batch';
                    } else {
                        restEndpoint += '/approval-state/batch';
                        restOptions.params.targetApprovalState = api.vmp(targetState);
                    }
                    return $http.post(restEndpoint, studyIds, restOptions);
                },

                vmp(approvalStateUrn) {
                    // return enum value for urn
                    return _.invert(APPROVAL_STATE)[approvalStateUrn];
                },

                resolveName(studyOrApprovalStateUrn) {
                    let approvalStateUrn = studyOrApprovalStateUrn;
                    if (_.has(studyOrApprovalStateUrn, 'approvalState')) {
                        approvalStateUrn = studyOrApprovalStateUrn.approvalState;
                    }

                    const approvalState = approvalStateUrn ? approvalStateModel.get({ urn: approvalStateUrn }) : undefined;

                    return approvalState ? approvalState.name : undefined;
                },
            };

            return api;
        },
    ]);
})();
